"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStore = exports.Permissions = void 0;
var mobx_1 = require("mobx");
var config_1 = __importDefault(require("config"));
var Store_1 = require("./Store");
var Permissions;
(function (Permissions) {
    Permissions[Permissions["STAGE_1"] = 1] = "STAGE_1";
    Permissions[Permissions["STAGE_2"] = 2] = "STAGE_2";
    Permissions[Permissions["STAGE_3"] = 3] = "STAGE_3";
    Permissions[Permissions["STAGE_4"] = 4] = "STAGE_4";
    Permissions[Permissions["PRICE_QUERY_LEVEL_1"] = 5] = "PRICE_QUERY_LEVEL_1";
    Permissions[Permissions["PRICE_QUERY_LEVEL_2"] = 6] = "PRICE_QUERY_LEVEL_2";
    Permissions[Permissions["PRICE_QUERY_LEVEL_3"] = 7] = "PRICE_QUERY_LEVEL_3";
    Permissions[Permissions["PRICE_QUERY_LEVEL_4"] = 8] = "PRICE_QUERY_LEVEL_4";
    Permissions[Permissions["PRICE_QUERY_LEVEL_5"] = 9] = "PRICE_QUERY_LEVEL_5";
    Permissions[Permissions["FLEET_QUERY_LEVEL_1"] = 10] = "FLEET_QUERY_LEVEL_1";
    Permissions[Permissions["FLEET_QUERY_LEVEL_2"] = 11] = "FLEET_QUERY_LEVEL_2";
    Permissions[Permissions["FLEET_QUERY_LEVEL_3"] = 12] = "FLEET_QUERY_LEVEL_3";
    Permissions[Permissions["FLEET_QUERY_LEVEL_4"] = 13] = "FLEET_QUERY_LEVEL_4";
    Permissions[Permissions["FLEET_QUERY_LEVEL_5"] = 14] = "FLEET_QUERY_LEVEL_5";
    Permissions[Permissions["POD_QUERY_CREDIT_TEAM"] = 15] = "POD_QUERY_CREDIT_TEAM";
    Permissions[Permissions["POD_QUERY_CUSTOMER_SERVICES_TEAM"] = 16] = "POD_QUERY_CUSTOMER_SERVICES_TEAM";
    Permissions[Permissions["POD_QUERY_WAREHOUSE_TEAM"] = 17] = "POD_QUERY_WAREHOUSE_TEAM";
    Permissions[Permissions["PRICE_QUERY_LEVEL_6"] = 18] = "PRICE_QUERY_LEVEL_6";
    Permissions[Permissions["PRICE_QUERY_EDIT_LEVEL_2"] = 19] = "PRICE_QUERY_EDIT_LEVEL_2";
    Permissions[Permissions["POD_QUERY_STAGE_3_EDIT"] = 20] = "POD_QUERY_STAGE_3_EDIT";
    Permissions[Permissions["PRICE_QUERY_EDIT_LEVEL_4"] = 21] = "PRICE_QUERY_EDIT_LEVEL_4";
    Permissions[Permissions["FLEET_QUERY_LEVEL_6"] = 22] = "FLEET_QUERY_LEVEL_6";
    Permissions[Permissions["FLEET_QUERY_LEVEL_7"] = 23] = "FLEET_QUERY_LEVEL_7";
    Permissions[Permissions["REOPEN_QUERY"] = 24] = "REOPEN_QUERY";
    Permissions[Permissions["PRICE_QUERY_LEVEL_0"] = 25] = "PRICE_QUERY_LEVEL_0";
})(Permissions = exports.Permissions || (exports.Permissions = {}));
var storage_keys = config_1.default.storage_keys, user_roles = config_1.default.user_roles;
var UserStore = /** @class */ (function (_super) {
    __extends(UserStore, _super);
    function UserStore(data) {
        var _this = _super.call(this, data) || this;
        _this.setData = function (data) {
            if (localStorage.getItem(storage_keys.USER) == null)
                localStorage.setItem(storage_keys.USER, JSON.stringify(data));
            _this.data = data;
        };
        _this.unsetData = function () {
            localStorage.removeItem(storage_keys.USER);
            _this.data = null;
        };
        return _this;
    }
    Object.defineProperty(UserStore.prototype, "isAdmin", {
        get: function () {
            console.log(this.data.roles);
            return this.data.roles.includes(user_roles.ADMIN);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "isSuperAdmin", {
        get: function () {
            return this.data.roles.includes(user_roles.SUPER_ADMIN);
        },
        enumerable: false,
        configurable: true
    });
    UserStore.prototype.hasPermission = function (permission) {
        for (var _i = 0, _a = this.data.permissions; _i < _a.length; _i++) {
            var userPermission = _a[_i];
            if (userPermission.id === permission)
                return true;
        }
        return false;
    };
    Object.defineProperty(UserStore.prototype, "levelPermission", {
        get: function () {
            for (var _i = 0, _a = this.data.permissions; _i < _a.length; _i++) {
                var userPermission = _a[_i];
                if (userPermission.name.indexOf("authorisation") > -1) {
                    return parseInt(userPermission.name.match(/\d/g).join(""));
                }
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    UserStore.prototype.levelPricePermission = function (level) {
        for (var _i = 0, _a = this.data.permissions; _i < _a.length; _i++) {
            var userPermission = _a[_i];
            if (userPermission.name.indexOf("price-query-authorisation-level-" + level) > -1) {
                return true;
            }
        }
        return false;
    };
    UserStore.prototype.levelFleetPermission = function (level) {
        for (var _i = 0, _a = this.data.permissions; _i < _a.length; _i++) {
            var userPermission = _a[_i];
            if (userPermission.name.indexOf("fleet-query-authorisation-level-" + level) > -1) {
                return true;
            }
        }
        return false;
    };
    __decorate([
        mobx_1.computed
    ], UserStore.prototype, "isAdmin", null);
    __decorate([
        mobx_1.computed
    ], UserStore.prototype, "isSuperAdmin", null);
    __decorate([
        mobx_1.computed
    ], UserStore.prototype, "levelPermission", null);
    return UserStore;
}(Store_1.Store));
exports.UserStore = UserStore;
var userStore = new UserStore(null);
exports.default = userStore;
